import { BaseRequest } from '@/_metronic/helpers/crud-helper/base-request'
import {
  DropdownSelectAsyncPaginate,
  OptionType,
} from '@/_metronic/partials/content/dropdown-select/DropdownSelectAsyncPaginate'
import { FilterOutlet } from '@/app/modules/outlet/core/_models'
import { getOutlets } from '@/app/modules/outlet/core/_requests'
import { FC, useEffect, useState } from 'react'
import { MultiValue } from 'react-select'

type Props = {
  currentValue: OptionType | MultiValue<OptionType> | null
  onValueChange: any
  placeholder: string
  isDisabled: boolean
}

const FilterDropdownOutlet: FC<Props> = ({
  currentValue,
  onValueChange,
  placeholder,
  isDisabled,
}) => {
  const [_, onChange] = useState<OptionType | MultiValue<OptionType> | null>(currentValue || null)

  const loadOptionsOutlets = async (search: string, page: number) => {
    try {
      const body = {
        filter: {
          name: search,
          set_name: search?.length > 0,
        },
        page: page,
        limit: 10,
        sort: 'ASC',
        order: 'name',
      } as BaseRequest<FilterOutlet>

      const resp = await getOutlets(body)
      if (resp?.response?.data) {
        const {data} = resp.response
        return {
          options: data?.map((x) => ({label: x.name, value: x.guid})),
          hasMore: page < (resp?.response?.total_page || 0),
        }
      }

      return {options: [], hasMore: false, additional: page}
    } catch (error) {
      return {
        options: [],
        hasMore: false,
      }
    }
  }

  const loadOptions: any = async (q, _, additional) => {
    const {page} = additional!
    const {options: responseOptions, hasMore} = await loadOptionsOutlets(q, page)

    return {
      options: responseOptions,
      hasMore,
      additional: {
        page: page + 1,
      },
    }
  }

  useEffect(() => {
    onValueChange(currentValue)
  }, [currentValue])

  return (
    <DropdownSelectAsyncPaginate
      key={'outlet'}
      placeholder={placeholder}
      loadOptions={loadOptions}
      onChange={(newValues) => onValueChange(newValues)}
      value={currentValue}
      isClearable
      isMulti
      isDisabled={isDisabled}
    />
  )
}

export { FilterDropdownOutlet }

